import { createFileRoute } from '@tanstack/react-router';
import { usersSearchSchema } from '@/features/settings/users/api';
import { UsersPage } from '@/features/settings/users/users-page';

// S25 · Users & access: the audit log's filters (who, what, period) live in the URL.
export const Route = createFileRoute('/_app/settings/users')({
  validateSearch: usersSearchSchema,
  component: UsersPage,
});
